<template>
  <div class="menu-container" :class="color">
    <div class="line-bar"></div>
    <div class="header-wrapper">
      <div id="shopify-section-header" class="shopify-section">
        <div
          data-section-id="header"
          data-section-type="header-section"
          class="header-layout-02"
        >
          <!--       
        -->
          <!-- Header Code  -->
          <div id="header-content">
            <div class="header is-ticky">
              <div class="container container-menu">
                <div class="header-inner">
                  <div class="row">
                    <div class="logo-container">
                      <h1
                        class="logo"
                        itemscope=""
                        itemtype="http://schema.org/Organization"
                      >
                        <a href="/">
                          <img
                            v-if="!color"
                            src="//cdn.shopify.com/s/files/1/0019/8865/7187/files/logo-transparent-400x200_2048x.png?v=1602227602"
                            alt="Garlan's, Inc."
                            style="height: 50px; width: auto"
                          />
                          <img
                            v-else
                            src="//cdn.shopify.com/s/files/1/0019/8865/7187/files/logo-transparent-white-400x200_2048x.png?v=1602227667"
                            alt="Garlan's, Inc."
                            style="height: 50px; width: auto"
                          />
                        </a>
                      </h1>

                    </div>
                    <div
                      class="col-lg-2 col-md-3 col-sm-12 col-12 credit-container"
                      style="padding-right: 0px"
                    >
                      <a
                        class="apply-credit-btn"
                        href="https://apply.garlans.com/"
                        >Apply for credit</a
                      >
                    </div>
                    <div class="col-lg-2 col-md-3 col-sm-12 col-12 credit-container">
                      <a
                        class="pay-credit-btn"
                        href="https://apply.garlans.com/abonar-credito/"
                        >Pay your credit</a
                      >
                    </div>
                  </div>
                  <div class="row">
                    <div class="menu-main-home menu col-md-12 col-sm-12 col-12">
                      <div class="menu-top">
                        <div class="menu-action">
                          <!--Top Menu -->

                          <div class="megamenu">
                            <ul class="navbar-nav site-nav">
                              <li class="level-top">
                                <a href="/" class="">
                                  <span>Home</span>
                                </a>
                              </li>

                              <li class="level-top menu-dropdown">
                                <a href="https://www.garlans.com/collections/womens" class="">
                                  <span>Women</span>
                                  <i class="cs-font clever-icon-down"></i
                                ></a>

                                <div class="dropdown-sub level1">
                                  <div class="container">
                                    <ul>
                                      <span class="title-submenu">Women</span>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-tops"
                                          class=""
                                        >
                                          <span>Women's Tops</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-bottoms"
                                          class=""
                                        >
                                          <span>Women's Bottoms</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-coats-jackets"
                                          class=""
                                        >
                                          <span
                                            >Women's Coats &amp; Jackets</span
                                          >
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-sweaters"
                                          class=""
                                        >
                                          <span>Women's Sweaters</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-pajamas-robes"
                                          class=""
                                        >
                                          <span
                                            >Women's Pajamas &amp; Robes</span
                                          >
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-dresses"
                                          class=""
                                        >
                                          <span>Women's Dresses</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-swimwear"
                                          class=""
                                        >
                                          <span>Women’s Swimwear</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li class="level-top menu-dropdown">
                                <a href="https://www.garlans.com/collections/mens" class="">
                                  <span>Men</span>
                                  <i class="cs-font clever-icon-down"></i
                                ></a>

                                <div class="dropdown-sub level1">
                                  <div class="container">
                                    <ul>
                                      <span class="title-submenu">Men</span>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-shirts"
                                          class=""
                                        >
                                          <span>Men's Shirts</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-t-shirts"
                                          class=""
                                        >
                                          <span>Men's T-Shirts</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-polos"
                                          class=""
                                        >
                                          <span>Men's Polos</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-sweaters"
                                          class=""
                                        >
                                          <span>Men's Sweaters</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-bottoms"
                                          class=""
                                        >
                                          <span>Men's Bottoms</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-activewear"
                                          class=""
                                        >
                                          <span>Men's Activewear</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-coats-jackets"
                                          class=""
                                        >
                                          <span>Men's Coats &amp; Jackets</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-underwear"
                                          class=""
                                        >
                                          <span>Men's Underwear</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-dress-shirts"
                                          class=""
                                        >
                                          <span>Men's Dress Shirts</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-suits"
                                          class=""
                                        >
                                          <span>Men's Suits</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li class="level-top menu-dropdown">
                                <a href="https://www.garlans.com/collections/juniors" class="">
                                  <span>Juniors</span>
                                  <i class="cs-font clever-icon-down"></i
                                ></a>

                                <div class="dropdown-sub level1">
                                  <div class="container">
                                    <ul>
                                      <span class="title-submenu">Juniors</span>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/juniors-tops-blouses"
                                          class=""
                                        >
                                          <span
                                            >Junior's Tops &amp; Blouses</span
                                          >
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/juniors-bottoms"
                                          class=""
                                        >
                                          <span>Junior's Bottoms</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/juniors-t-shirts"
                                          class=""
                                        >
                                          <span>Junior's T-Shirts</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/juniors-sweaters"
                                          class=""
                                        >
                                          <span>Junior's Sweaters</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/juniors-activewear"
                                          class=""
                                        >
                                          <span>Junior's Activewear</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/juniors-coats-jackets"
                                          class=""
                                        >
                                          <span
                                            >Junior's Coats &amp; Jackets</span
                                          >
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/juniors-dresses"
                                          class=""
                                        >
                                          <span>Junior's Dresses</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li class="level-top menu-dropdown">
                                <a href="/pages/shoes" class="">
                                  <span>Shoes</span>
                                  <i class="cs-font clever-icon-down"></i
                                ></a>

                                <div class="dropdown-sub level1">
                                  <div class="container">
                                    <ul>
                                      <span class="title-submenu">Shoes</span>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-casual-shoes"
                                          class=""
                                        >
                                          <span>Women's Casual Shoes</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-athletic-shoes"
                                          class=""
                                        >
                                          <span>Women's Athletic Shoes</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-boots"
                                          class=""
                                        >
                                          <span>Women's Boots</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-casual-shoes"
                                          class=""
                                        >
                                          <span>Men's Casual Shoes</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-boots"
                                          class=""
                                        >
                                          <span>Men's Boots</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-athletic-shoes"
                                          class=""
                                        >
                                          <span>Men's Athletic Shoes</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li class="level-top menu-dropdown">
                                <a href="/pages/accessories-1" class="">
                                  <span>Accessories</span>
                                  <i class="cs-font clever-icon-down"></i
                                ></a>

                                <div class="dropdown-sub level1">
                                  <div class="container">
                                    <ul>
                                      <span class="title-submenu"
                                        >Accessories</span
                                      >

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-accessories"
                                          class=""
                                        >
                                          <span>Women's Accessories</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-watches"
                                          class=""
                                        >
                                          <span>Women's Watches</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-sunglasses"
                                          class=""
                                        >
                                          <span>Women's Sunglasses</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-handbags"
                                          class=""
                                        >
                                          <span>Women's Handbags</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-wallets"
                                          class=""
                                        >
                                          <span>Women's Wallets</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-watches"
                                          class=""
                                        >
                                          <span>Men's Watches</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-sunglasses"
                                          class=""
                                        >
                                          <span>Men's Sunglasses</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-hats"
                                          class=""
                                        >
                                          <span>Men's Hats</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-wallets"
                                          class=""
                                        >
                                          <span>Men's Wallets</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-ties"
                                          class=""
                                        >
                                          <span>Men's Ties</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li class="level-top menu-dropdown">
                                <a href="/pages/fragrances" class="">
                                  <span>Fragrances</span>
                                  <i class="cs-font clever-icon-down"></i
                                ></a>

                                <div class="dropdown-sub level1">
                                  <div class="container">
                                    <ul>
                                      <span class="title-submenu"
                                        >Fragrances</span
                                      >

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/womens-fragrances"
                                          class=""
                                        >
                                          <span>Women's Fragrances</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/mens-fragrances"
                                          class=""
                                        >
                                          <span>Men's Fragrances</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>

                              <li class="level-top menu-dropdown">
                                <a href="https://www.garlans.com/collections/clearance" class="">
                                  <span>Clearance</span>
                                  <i class="cs-font clever-icon-down"></i
                                ></a>

                                <div class="dropdown-sub level1">
                                  <div class="container">
                                    <ul>
                                      <span class="title-submenu"
                                        >Clearance</span
                                      >

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/clearance/Clearance-Womens"
                                          class=""
                                        >
                                          <span>Clearance Womens</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/clearance/Clearance-Mens"
                                          class=""
                                        >
                                          <span>Clearance Mens</span>
                                        </a>
                                      </li>

                                      <li class="">
                                        <a
                                          href="https://www.garlans.com/collections/clearance/Clearance-Juniors"
                                          class=""
                                        >
                                          <span>Clearance Juniors</span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>

                          <!-- End Menu -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nm-page-overlay"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      colorHead: String,
      default: ''
    },
  }
};
</script>

<style scoped>
/* cleversoft Icon */
@font-face { font-family: 'cleversoft'; src: url('../assets/cleversoft.woff2') format('woff2'); font-weight: normal; font-style: normal; } .cs-font { /* use !important to prevent issues with browser extensions that change fonts */ font-family: 'cleversoft' !important; speak: none; font-style: normal; font-weight: normal; font-variant: normal; text-transform: none; line-height: 1; /* Better Font Rendering =========== */ -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; } .clever-icon-law-1:before { content: "\c327"; } .clever-icon-law:before { content: "\c326"; } .clever-icon-image-box:before { content: "\c325"; } .clever-icon-fire:before { content: "\c324"; } .clever-icon-icon-box:before { content: "\c323"; } .clever-icon-editor:before { content: "\c322"; } .clever-icon-column:before { content: "\c321"; } .clever-icon-grid-6:before { content: "\c320"; } .clever-icon-button:before { content: "\c319"; } .clever-icon-quote-3:before { content: "\c318"; } .clever-icon-layer:before { content: "\c317"; } .clever-icon-carousel:before { content: "\c316"; } .clever-icon-banner:before { content: "\c315"; } .clever-icon-heading:before { content: "\c314"; } .clever-icon-click:before { content: "\c313"; } .clever-icon-cookie:before { content: "\c312"; } .clever-icon-tab:before { content: "\c311"; } .clever-icon-slider:before { content: "\c310"; } .clever-icon-recent-blog .path1:before { content: "\c300"; color: rgb(0, 0, 0); } .clever-icon-recent-blog .path2:before { content: "\c301"; margin-left: -1.25em; color: rgb(0, 0, 0); } .clever-icon-recent-blog .path3:before { content: "\c302"; margin-left: -1.25em; color: rgb(0, 0, 0); } .clever-icon-recent-blog .path4:before { content: "\c303"; margin-left: -1.25em; color: rgb(0, 0, 0); } .clever-icon-recent-blog .path5:before { content: "\c304"; margin-left: -1.25em; color: rgb(0, 0, 0); } .clever-icon-recent-blog .path6:before { content: "\c305"; margin-left: -1.25em; color: rgb(255, 255, 255); } .clever-icon-recent-blog .path7:before { content: "\c306"; margin-left: -1.25em; color: rgb(0, 0, 0); } .clever-icon-blog:before { content: "\c299"; } .clever-icon-wallet-1:before { content: "\c298"; } .clever-icon-handshake:before { content: "\c297"; } .clever-icon-undo-1:before { content: "\c296"; } .clever-icon-plane-3:before { content: "\c295"; } .clever-icon-plane-2:before { content: "\c294"; } .clever-icon-clock-4:before { content: "\c293"; } .clever-icon-play-4:before { content: "\c292"; } .clever-icon-play-3:before { content: "\c291"; } .clever-icon-face-1:before { content: "\c290"; } .clever-icon-comment-1:before { content: "\c289"; } .clever-icon-comment-2:before { content: "\c288"; } .clever-icon-comment-3:before { content: "\c287"; } .clever-icon-comment-4:before { content: "\c286"; } .clever-icon-360-2:before { content: "\c284"; } .clever-icon-360-1:before { content: "\c283"; } .clever-icon-heart-6:before { content: "\c282"; } .clever-icon-heart-5:before { content: "\c281"; } .clever-icon-filter-3:before { content: "\c285"; } .clever-icon-refresh-5:before { content: "\c280"; } .clever-icon-heart-4:before { content: "\c279"; } .clever-icon-heart-3:before { content: "\c278"; } .clever-icon-ruler:before { content: "\c277"; } .clever-icon-help:before { content: "\c276"; } .clever-icon-hand-up:before { content: "\c275"; } .clever-icon-hand-down:before { content: "\c274"; } .clever-icon-arrow-up:before { content: "\c273"; } .clever-icon-arrow-down:before { content: "\c272"; } .clever-icon-arrow-left-4:before { content: "\c271"; } .clever-icon-arrow-right-4:before { content: "\c270"; } .clever-icon-refresh-4:before { content: "\c269"; } .clever-icon-refresh-3:before { content: "\c268"; } .clever-icon-quote-2:before { content: "\c267"; } .clever-icon-pause:before { content: "\c266"; } .clever-icon-check:before { content: "\c265"; } .clever-icon-caret-down:before { content: "\c264"; } .clever-icon-caret-left:before { content: "\c263"; } .clever-icon-caret-right:before { content: "\c262"; } .clever-icon-caret-up:before { content: "\c261"; } .clever-icon-caret-square-dow:before { content: "\c260"; } .clever-icon-caret-square-left:before { content: "\c259"; } .clever-icon-caret-square-right:before { content: "\c258"; } .clever-icon-caret-square-up:before { content: "\c257"; } .clever-icon-check-circle-o:before { content: "\c256"; } .clever-icon-check-circle:before { content: "\c255"; } .clever-icon-check-square-o:before { content: "\c254"; } .clever-icon-check-square:before { content: "\c253"; } .clever-icon-circle-o:before { content: "\c252"; } .clever-icon-circle:before { content: "\c251"; } .clever-icon-dribbble:before { content: "\c250"; } .clever-icon-flickr:before { content: "\c249"; } .clever-icon-foursquare:before { content: "\c248"; } .clever-icon-github:before { content: "\c247"; } .clever-icon-linkedin:before { content: "\c246"; } .clever-icon-rss:before { content: "\c245"; } .clever-icon-square-o:before { content: "\c244"; } .clever-icon-square:before { content: "\c243"; } .clever-icon-star-o:before { content: "\c242"; } .clever-icon-star:before { content: "\c241"; } .clever-icon-tumblr:before { content: "\c240"; } .clever-icon-xing:before { content: "\c239"; } .clever-icon-twitter:before { content: "\c238"; } .clever-icon-cart-16:before { content: "\c237"; } .clever-icon-heart-2:before { content: "\c236"; } .clever-icon-eye-5:before { content: "\c235"; } .clever-icon-facebook:before { content: "\c234"; } .clever-icon-googleplus:before { content: "\c233"; } .clever-icon-instagram:before { content: "\c232"; } .clever-icon-pinterest:before { content: "\c231"; } .clever-icon-skype:before { content: "\c230"; } .clever-icon-vimeo:before { content: "\c229"; } .clever-icon-youtube-1:before { content: "\c228"; } .clever-icon-award-1:before { content: "\c227"; } .clever-icon-clock-3:before { content: "\c226"; } .clever-icon-three-dots:before { content: "\c225"; } .clever-icon-share-2:before { content: "\c224"; } .clever-icon-building:before { content: "\c223"; } .clever-icon-faucet:before { content: "\c222"; } .clever-icon-flower:before { content: "\c221"; } .clever-icon-house-1:before { content: "\c220"; } .clever-icon-house:before { content: "\c219"; } .clever-icon-pines:before { content: "\c218"; } .clever-icon-plant:before { content: "\c217"; } .clever-icon-sprout-1:before { content: "\c216"; } .clever-icon-sprout:before { content: "\c215"; } .clever-icon-trees:before { content: "\c214"; } .clever-icon-close-1:before { content: "\c213"; } .clever-icon-list-2:before { content: "\c212"; } .clever-icon-grid-5:before { content: "\c211"; } .clever-icon-menu-6:before { content: "\c210"; } .clever-icon-three-dots-o:before { content: "\c209"; } .clever-icon-list-1:before { content: "\c208"; } .clever-icon-menu-5:before { content: "\c207"; } .clever-icon-menu-4:before { content: "\c206"; } .clever-icon-heart-1:before { content: "\c205"; } .clever-icon-user-6:before { content: "\c204"; } .clever-icon-attachment:before { content: "\c203"; } .clever-icon-cart-18:before { content: "\c202"; } .clever-icon-ball:before { content: "\c201"; } .clever-icon-battery:before { content: "\c200"; } .clever-icon-briefcase:before { content: "\c199"; } .clever-icon-car:before { content: "\c198"; } .clever-icon-cpu-2:before { content: "\c197"; } .clever-icon-cpu-1:before { content: "\c196"; } .clever-icon-dress-woman:before { content: "\c195"; } .clever-icon-drill-tool:before { content: "\c194"; } .clever-icon-feeding-bottle:before { content: "\c193"; } .clever-icon-fruit:before { content: "\c192"; } .clever-icon-furniture-2:before { content: "\c191"; } .clever-icon-furniture-1:before { content: "\c190"; } .clever-icon-shoes-woman-2:before { content: "\c189"; } .clever-icon-shoes-woman-1:before { content: "\c188"; } .clever-icon-horse:before { content: "\c187"; } .clever-icon-laptop:before { content: "\c186"; } .clever-icon-lipstick:before { content: "\c185"; } .clever-icon-iron:before { content: "\c184"; } .clever-icon-perfume:before { content: "\c183"; } .clever-icon-baby-toy-2:before { content: "\c182"; } .clever-icon-baby-toy-1:before { content: "\c181"; } .clever-icon-paint-roller:before { content: "\c180"; } .clever-icon-shirt:before { content: "\c179"; } .clever-icon-shoe-man-2:before { content: "\c178"; } .clever-icon-small-diamond:before { content: "\c177"; } .clever-icon-tivi:before { content: "\c176"; } .clever-icon-smartphone:before { content: "\c175"; } .clever-icon-lights:before { content: "\c174"; } .clever-icon-microwave:before { content: "\c173"; } .clever-icon-wardrobe:before { content: "\c172"; } .clever-icon-washing-machine:before { content: "\c171"; } .clever-icon-watch-2:before { content: "\c170"; } .clever-icon-watch-1:before { content: "\c169"; } .clever-icon-slider-3:before { content: "\c168"; } .clever-icon-slider-2:before { content: "\c167"; } .clever-icon-slider-1:before { content: "\c166"; } .clever-icon-cart-15:before { content: "\c165"; } .clever-icon-cart-14:before { content: "\c164"; } .clever-icon-cart-13:before { content: "\c163"; } .clever-icon-cart-12:before { content: "\c162"; } .clever-icon-cart-11:before { content: "\c161"; } .clever-icon-cart-10:before { content: "\c160"; } .clever-icon-cart-9:before { content: "\c159"; } .clever-icon-cart-8:before { content: "\c158"; } .clever-icon-pause-1:before { content: "\c157"; } .clever-icon-arrow-left:before { content: "\c156"; } .clever-icon-arrow-left-1:before { content: "\c155"; } .clever-icon-arrow-left-2:before { content: "\c154"; } .clever-icon-arrow-left-3:before { content: "\c153"; } .clever-icon-arrow-right:before { content: "\c152"; } .clever-icon-arrow-right-1:before { content: "\c151"; } .clever-icon-arrow-right-2:before { content: "\c150"; } .clever-icon-arrow-right-3:before { content: "\c149"; } .clever-icon-plane-1:before { content: "\c148"; } .clever-icon-cart-17:before { content: "\c147"; } .clever-icon-filter-2:before { content: "\c146"; } .clever-icon-filter-1:before { content: "\c145"; } .clever-icon-grid-1:before { content: "\c144"; } .clever-icon-contract:before { content: "\c143"; } .clever-icon-expand:before { content: "\c142"; } .clever-icon-cart-7:before { content: "\c141"; } .clever-icon-quote-1:before { content: "\c140"; } .clever-icon-arrow-right-5:before { content: "\c139"; } .clever-icon-arrow-left-5:before { content: "\c138"; } .clever-icon-refresh-2:before { content: "\c137"; } .clever-icon-truck:before { content: "\c136"; } .clever-icon-wallet:before { content: "\c135"; } .clever-icon-electric-1:before { content: "\c134"; } .clever-icon-electric-2:before { content: "\c133"; } .clever-icon-lock:before { content: "\c132"; } .clever-icon-share-1:before { content: "\c131"; } .clever-icon-check-box:before { content: "\c130"; } .clever-icon-clock-2:before { content: "\c129"; } .clever-icon-analytics-laptop:before { content: "\c128"; } .clever-icon-code-design:before { content: "\c127"; } .clever-icon-competitive-chart:before { content: "\c126"; } .clever-icon-computer-monitor-and-cellphone:before { content: "\c125"; } .clever-icon-consulting-message:before { content: "\c124"; } .clever-icon-creative-process:before { content: "\c123"; } .clever-icon-customer-reviews:before { content: "\c122"; } .clever-icon-data-visualization:before { content: "\c121"; } .clever-icon-document:before { content: "\c120"; } .clever-icon-download-2:before { content: "\c119"; } .clever-icon-download-1:before { content: "\c118"; } .clever-icon-mail-6:before { content: "\c117"; } .clever-icon-file-sharing:before { content: "\c116"; } .clever-icon-finger-touch-screen:before { content: "\c115"; } .clever-icon-horizontal-tablet-with-pencil:before { content: "\c114"; } .clever-icon-illustration-tool:before { content: "\c113"; } .clever-icon-keyboard-and-hands:before { content: "\c112"; } .clever-icon-landscape-image:before { content: "\c111"; } .clever-icon-layout-squares:before { content: "\c110"; } .clever-icon-mobile-app-developing:before { content: "\c109"; } .clever-icon-online-purchase:before { content: "\c108"; } .clever-icon-online-shopping:before { content: "\c107"; } .clever-icon-online-video:before { content: "\c106"; } .clever-icon-clock-1:before { content: "\c105"; } .clever-icon-padlock-key:before { content: "\c104"; } .clever-icon-pc-monitor:before { content: "\c103"; } .clever-icon-place-localizer:before { content: "\c102"; } .clever-icon-search-results:before { content: "\c101"; } .clever-icon-search-tool:before { content: "\c100"; } .clever-icon-settings-tools:before { content: "\c099"; } .clever-icon-sharing-symbol:before { content: "\c098"; } .clever-icon-site-map:before { content: "\c097"; } .clever-icon-smartphone-2:before { content: "\c096"; } .clever-icon-tablet-2:before { content: "\c095"; } .clever-icon-thin-expand-arrows:before { content: "\c094"; } .clever-icon-upload-2:before { content: "\c093"; } .clever-icon-upload-1:before { content: "\c092"; } .clever-icon-volume-off:before { content: "\c091"; } .clever-icon-volume-on:before { content: "\c090"; } .clever-icon-news-list:before { content: "\c089"; } .clever-icon-desktop:before { content: "\c088"; } .clever-icon-news-grid:before { content: "\c087"; } .clever-icon-setting:before { content: "\c086"; } .clever-icon-web-home:before { content: "\c085"; } .clever-icon-web-link:before { content: "\c084"; } .clever-icon-web-links:before { content: "\c083"; } .clever-icon-website-protection:before { content: "\c082"; } .clever-icon-team:before { content: "\c081"; } .clever-icon-zoom-in:before { content: "\c080"; } .clever-icon-zoom-out:before { content: "\c079"; } .clever-icon-arrow-1:before { content: "\c078"; } .clever-icon-arrow-bold:before { content: "\c077"; } .clever-icon-arrow-light:before { content: "\c076"; } .clever-icon-arrow-regular:before { content: "\c075"; } .clever-icon-cart-1:before { content: "\c074"; } .clever-icon-cart-2:before { content: "\c073"; } .clever-icon-cart-3:before { content: "\c072"; } .clever-icon-cart-4:before { content: "\c071"; } .clever-icon-cart-5:before { content: "\c070"; } .clever-icon-cart-6:before { content: "\c069"; } .clever-icon-chart:before { content: "\c068"; } .clever-icon-close:before { content: "\c067"; } .clever-icon-compare-1:before { content: "\c066"; } .clever-icon-compare-2:before { content: "\c065"; } .clever-icon-compare-3:before { content: "\c064"; } .clever-icon-compare-4:before { content: "\c063"; } .clever-icon-compare-5:before { content: "\c062"; } .clever-icon-compare-6:before { content: "\c061"; } .clever-icon-compare-7:before { content: "\c060"; } .clever-icon-down:before { content: "\c059"; } .clever-icon-grid:before { content: "\c058"; } .clever-icon-hand:before { content: "\c057"; } .clever-icon-layout-1:before { content: "\c056"; } .clever-icon-layout:before { content: "\c055"; } .clever-icon-light:before { content: "\c054"; } .clever-icon-play-1:before { content: "\c053"; } .clever-icon-list:before { content: "\c052"; } .clever-icon-mail-1:before { content: "\c051"; } .clever-icon-mail-2:before { content: "\c050"; } .clever-icon-mail-3:before { content: "\c049"; } .clever-icon-mail-4:before { content: "\c048"; } .clever-icon-mail-5:before { content: "\c047"; } .clever-icon-map-1:before { content: "\c046"; } .clever-icon-map-2:before { content: "\c045"; } .clever-icon-map-3:before { content: "\c044"; } .clever-icon-map-4:before { content: "\c043"; } .clever-icon-map-5:before { content: "\c042"; } .clever-icon-menu-1:before { content: "\c041"; } .clever-icon-menu-2:before { content: "\c040"; } .clever-icon-grid-3:before { content: "\c039"; } .clever-icon-grid-4:before { content: "\c038"; } .clever-icon-menu-3:before { content: "\c037"; } .clever-icon-grid-2:before { content: "\c036"; } .clever-icon-minus:before { content: "\c035"; } .clever-icon-next:before { content: "\c034"; } .clever-icon-phone-1:before { content: "\c033"; } .clever-icon-phone-2:before { content: "\c032"; } .clever-icon-phone-3:before { content: "\c031"; } .clever-icon-phone-4:before { content: "\c030"; } .clever-icon-phone-5:before { content: "\c029"; } .clever-icon-phone-6:before { content: "\c028"; } .clever-icon-picture:before { content: "\c027"; } .clever-icon-pin:before { content: "\c026"; } .clever-icon-plus:before { content: "\c025"; } .clever-icon-prev:before { content: "\c024"; } .clever-icon-eye-4:before { content: "\c023"; } .clever-icon-eye-3:before { content: "\c022"; } .clever-icon-eye-2:before { content: "\c021"; } .clever-icon-eye-1:before { content: "\c020"; } .clever-icon-refresh-1:before { content: "\c019"; } .clever-icon-youtube-2:before { content: "\c018"; } .clever-icon-search-1:before { content: "\c017"; } .clever-icon-search-2:before { content: "\c016"; } .clever-icon-search-3:before { content: "\c015"; } .clever-icon-search-4:before { content: "\c014"; } .clever-icon-search-5:before { content: "\c013"; } .clever-icon-support:before { content: "\c012"; } .clever-icon-tablet-1:before { content: "\c011"; } .clever-icon-play-2:before { content: "\c010"; } .clever-icon-up:before { content: "\c009"; } .clever-icon-user-1:before { content: "\c008"; } .clever-icon-user-2:before { content: "\c007"; } .clever-icon-user-3:before { content: "\c006"; } .clever-icon-user-4:before { content: "\c005"; } .clever-icon-user-5:before { content: "\c004"; } .clever-icon-user:before { content: "\c003"; } .clever-icon-vector1:before { content: "\c002"; } .clever-icon-wishlist1:before { content: "\c001"; }

.menu-container{
  background-color: #fff;
}
.line-bar{
    position: fixed;
    width: 100%;
    height: 1px;
    background-color: rgba(0,0,0,0.10);
    top: 60px;
    z-index: 99999999999;
}
body .menu-top .menu-action,
body .menu-top .menu-action h1,
body .menu-top .menu-action h2,
body .menu-top .menu-action h3,
body .menu-top .menu-action h4,
body .menu-top .menu-action h5,
body .menu-top .menu-action h6 {
  font-family: Poppins, sans-serif;
}
.product-img-box .zoom img {
  width: 100%;
}

a ,
a:hover,
a:focus {
  color: #000;
  font-weight: 400;
  font-family: Poppins, sans-serif !important;
  font-size: 14px !important;
}

.site-nav {
  width: 100%;
  margin: 0;
  padding: 0;
}
.site-nav li {
  display: block;
  margin: 0;
}
.site-nav a {
  display: block;
  padding: 12px 0;
  text-decoration: none; /* white-space: nowrap; */
}
.site-nav > li {
  position: relative;
  display: inline-block;
  list-style: none;
}
.site-nav > li > a {
  text-transform: uppercase;
  padding: 33px 18px 15px;
  letter-spacing: 0;
  font-size: 18px;
  line-height: 25px;
  font-weight: 400;
  position: relative;
}
.header.is-ticky .site-nav > li > a {
  padding-top: 0;
}
.black .header.is-ticky .site-nav > li > a {
  color: #fff !important;
}
.header.is-ticky .menu-top {
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
}
.header-layout-1 .header.is-ticky .menu-top {
  margin-top: 31px;
}
.header.is-ticky .info-contact-top {
  padding-top: 20px;
}
.nav-dropdown {
  background: #272727;
  text-align: left;
  display: none;
  position: absolute;
  top: 78px;
  left: 0;
  width: 215px;
  z-index: 5;
  padding: 15px 20px;
  margin-bottom: 0;
  border: 1px solid transparent;
}
.nav-dropdown li a {
  padding: 8px 0px 8px 0px;
  position: relative;
}
.wrapper-container .nav-dropdown ul {
  left: 100%;
  top: -1px;
  display: none;
}
.wrapper-container .site-nav > .menu-dropdown:hover > ul,
.wrapper-container .site-nav > .menu-dropdown.open > ul {
  display: block;
}
.wrapper-container .site-nav > li > ul > .menu-dropdown:hover > ul,
.wrapper-container .site-nav > li > ul > .menu-dropdown.open > ul {
  display: block;
}
.wrapper-container .site-nav > li > ul > li > ul > .menu-dropdown:hover > ul,
.wrapper-container .site-nav > li > ul > li > ul > .menu-dropdown.open > ul {
  display: block;
}
.wrapper-container
  .site-nav
  > li
  > ul
  > li
  > ul
  > li
  > ul
  > .menu-dropdown:hover
  > ul,
.wrapper-container
  .site-nav
  > li
  > ul
  > li
  > ul
  > ul
  > li
  > .menu-dropdown.open
  > ul {
  display: block;
}
.mega-style-2.dropdown-menu-inner > a.image-left {
  position: relative;
}
.mega-style-2 .text-float-right {
  width: 100%;
}
.dropdown-sub.sub-1 .dropdown-menu-inner.mega-style-2 .mega-item {
  position: absolute;
  right: 0;
  top: 0;
}

#back-top a {
  z-index: 99;
  border: 2px solid #000;
  height: 36px;
  position: fixed;
  right: 40px;
  bottom: 25px;
  width: 36px;
  cursor: pointer;
  margin: 0;
  text-align: center;
  line-height: 36px;
  font-size: 12px;
  border-radius: 100%;
  background: #fff;
}
#back-top a:hover {
  background: #000;
  color: #fff;
}

/* Mega Menu */
.site-nav > li.mega-menu.level-top.full-width {
  position: static;
}
.site-nav > li.mega-menu.level-top {
  position: relative;
}
.wrapper-container .site-nav li.mega-menu:hover .nav-dropdown {
  display: block;
}
.wrapper-container .site-nav li.dropdown:hover.mega-menu > a > .icon-dropdown {
  border-top-color: #fff;
  opacity: 1;
}
.wrapper-container .site-nav li.mega-menu .nav-dropdown {
  width: auto;
  left: 0%;
  right: 0%;
  border: 0;
  padding: 40px 45px;
}
.wrapper-container .site-nav li.mega-menu .nav-dropdown img {
  margin-top: 37px;
}
.nav-dropdown .menu-group ul.menu-dropdown {
  display: block;
  position: static;
  padding: 0;
}
.site-nav li.mega-menu > .menu-dropdown:hover > .nav-dropdown,
.site-nav li.mega-menu > .menu-dropdown.open > .nav-dropdown {
  display: block;
}
.sub-mega-menu {
  display: none;
}
.nav-dropdown {
  background: #fff;
  text-align: left;
  display: none;
  position: absolute;
  top: 62px;
  left: 0;
  width: 215px;
  z-index: 999;
  padding: 15px 20px;
  margin-bottom: 0;
  border: 1px solid transparent;
}
.nav-dropdown li a {
  padding: 8px 0px 8px 0px;
  position: relative;
}
.site-nav .menu-dropdown .dropdown-sub .menu-title {
  text-transform: capitalize;
  letter-spacing: 0;
  padding: 0;
}
.site-nav .menu-dropdown .dropdown-sub .menu-title a {
  font-weight: bold !important;
  padding-bottom: 0 !important;
  color: #000 !important;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 1.2;
}
.site-nav li .dropdown-sub {
  top: 100%;
}
.site-nav .dropdown-sub.level1 li.menu-dropdown {
  position: relative;
}
.site-nav li:hover .dropdown-sub.level1,
.site-nav .dropdown-sub.level1 li:hover .dropdown-sub.level2 {
  opacity: 1;
  top: 100%;
  display: block;
  z-index: 999;
  visibility: visible;
  left: 0;
  transform: translateX(0);
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -o-transform: translateX(0);
  -ms-transform: translateX(0);
}
.site-nav .dropdown-sub.level1 li .dropdown-sub.level2 {
  left: 100%;
}
.site-nav .dropdown-sub.level1 li:hover .dropdown-sub.level2 {
  left: 100%;
  top: -15px;
}
.site-nav li > .dropdown-sub {
  box-shadow: none;
}
.site-nav li.megamenu-dropdow > .dropdown-subs:after {
  content: "";
  background: #fff;
  width: 3000px;
  height: 100%;
  top: 0;
  right: 0px;
  position: absolute;
  z-index: -1;
}
.site-nav li.megamenu-dropdow > .dropdown-subs:before {
  content: "";
  background: #fff;
  width: 3000px;
  height: 100%;
  top: 0;
  left: 0px;
  position: absolute;
  z-index: -1;
}
.site-nav .menu-dropdown li a {
  font-size: 13px;
  letter-spacing: 0.5px;
  font-weight: 400;
  text-transform: capitalize;
  line-height: 15px;
}
.site-nav li .level1 li a {
  padding-left: 20px;
  position: relative;
}
.megamenu .site-nav li .dropdown-sub li a i {
  position: absolute;
  right: 20px;
  top: 0;
  line-height: 30px;
}
.site-nav .level-top > a i {
  margin-left: 5px;
  font-size: 8px;
  font-weight: bold;
}
.dropdown-toggle::after {
  display: none;
}
.dropdown-sub {
  left: 0;
  transition: all 0.3s ease-in-out 0s;
  -moz-transition: all 0.3s ease-in-out 0s;
  -webkit-transition: all 0.3s ease-in-out 0s;
  -ms-transition: all 0.3s ease-in-out 0s;
  opacity: 0;
  position: absolute;
  text-align: left;
  top: 100px;
  visibility: hidden;
  width: 100%;
  min-width: 220px;
  z-index: -1;
  transform: translateX(0);
  -webkit-transform: translateX(0);
  -moz-transform: translateX(0);
  -o-transform: translateX(0);
  -ms-transform: translateX(0);
  left: 0;
  -webkit-box-shadow: -2px 2px 82px -26px rgba(0, 0, 0, 0.25);
  box-shadow: -2px 2px 82px -26px rgba(0, 0, 0, 0.25);
}
.level1 .parent.dropdown-submenu:hover .dropdown-menu.level2,
.level2 .parent.dropdown-submenu:hover .dropdown-menu.level3 {
  -webkit-transition: all 0.5s ease-in-out 0s;
  -moz-transition: all 0.5s ease-in-out 0s;
  -o-transition: all 0.5s ease-in-out 0s;
  -ms-transition: all 0.5s ease-in-out 0s;
  opacity: 1;
  overflow: visible;
  top: 0;
  z-index: 2;
}
.dropdown-sub .dropdown-menu {
  background-color: #fff;
  border: 0 none;
  border-radius: 0;
  box-shadow: initial;
  display: block;
  left: 100%;
  margin: 0;
  min-width: 240px;
  opacity: 0;
  overflow: hidden;
  padding: 0;
  top: 100px;
  z-index: -1;
  transition: all 0.5s ease-in-out 0s;
  -webkit-transition: all 0.5s ease-in-out 0s;
  -moz-transition: all 0.5s ease-in-out 0s;
  -o-transition: all 0.5s ease-in-out 0s;
  -ms-transition: all 0.5s ease-in-out 0s;
  position: absolute;
}
.site-nav .level-top:first-child > a:hover:after,
.header .site-nav li.has_arrow:first-child > a:after,
.header .site-nav li.menu-dropdown.level-top:first-child > a:hover:after {
  left: 0;
  transform: translateX(0);
}
.header-inner .site-nav {
  display: inline-block;
  /* float: none;
  position: static;
  width: auto; */
}
.menu-title {
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: bold;
  text-transform: capitalize;
  letter-spacing: 1px;
}
.site-nav li .dropdown-sub li a {
  font-size: 14px;
  padding: 15px 0;
  text-transform: capitalize;
  font-weight: 400;
  line-height: 16px;
  margin-top: 0;
}
.dropdown-menu-inner {
  padding: 0 15px;
}
.site-nav li.mega-menu:hover .dropdown-sub > div,
.site-nav li.mega-menu .dropdown-sub > div {
  padding: 15px 15px 0;
}
.mega-menu.level-top .mega-item .row > div {
  border-right: 1px solid #ebebeb;
}
#header-content .header-inner .site-nav li a.image-left,
#header-content .header-inner .site-nav li a.image-left img {
  padding-bottom: 0 !important;
  margin-top: 0 !important;
  width: 100%;
}
.dropdown-sub .owl-wrapper .owl-item {
  padding: 0 40px 0 0;
}
.megamenu-product .product-content h3 {
  border: none;
  padding: 0;
}
.dropdown-sub .megamenu-product .product-item .spr-badge,
.dropdown-sub #product-menu .price-box {
  display: none;
}
.dropdown-sub .megamenu-product .product-item .add-to-cart-btn {
  margin-top: 0;
}
.megamenu-product .product-item a.grid-image {
  padding-top: 0;
}
.dropdown-sub .block-html .content > h3 {
  color: #fff;
  font-size: 14px;
  margin-bottom: 10px;
  margin-top: 15px;
}
.dropdown-sub .block-html .content > p {
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 0;
}
.dropdown-sub .block-html .content .link-more a {
  color: #af5875;
}
.dropdown-sub .block-html .content .link-more a:hover {
  color: #666;
}
/* Display Left */
#displayTextLeft {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  background: rgba(0, 0, 0, 0.9);
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  padding: 0 20px;
  position: fixed;
  left: 0;
  bottom: 0;
  height: 36px;
  line-height: 36px;
  width: 100%;
  text-align: center;
  display: none;
}

.title-submenu {
  color: #000 !important;
  font-weight: bold !important;
}
.header .dropdown-sub {
  background-color: #ededed !important;
  position: fixed;
  height: fit-content;
  height: -moz-max-content;
  width: 100vw;
  top: 110px !important;
}
.header .dropdown-sub li a {
  color: #000 !important;
}
.header .dropdown-sub li a:hover,
.header .dropdown-sub li a:focus {
  color: #bc3c52 !important;
}
.nav-bar {
  -webkit-animation-duration: 0.8s;
  -moz-animation-duration: 0.8s;
  -o-animation-duration: 0.8s;
  animation-duration: 0.8s;
}
.nav-bar.on {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 999;
}
.tabs-product {
  padding: 0;
  position: relative;
  overflow: hidden;
}
.tabs-title {
  padding: 0 1em;
  background: #ccc;
  border-top: 2px solid #eee;
  color: #222;
  float: left;
  line-height: 3;
  height: 3em;
  cursor: pointer;
  margin-right: 0.25em;
}
.tabs-content {
  float: right;
  width: 100%;
  margin: 1em 0 0 -100%;
  padding: 2em;
  background: silver;
}
.tabs-title:hover,
.tabs-title.active {
  background: silver;
  color: white;
}

.tabs-title.active {
  border-top-color: lime;
}
.owl-wrapper .owl-item {
  float: left;
  margin-bottom: 20px;
}
.header-right {
  height: 100px;
}
.top-icon-cart {
  display: inline-block;
  padding-left: 10px;
}
#header-content.is-ticky {
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 999;
  top: 0;
}

#header-content.is-ticky .menu-action .site-nav li a {
  color: #999 !important;
}
.menu-top .header-cart {
  z-index: 2;
  padding-top: 32px;
  padding-left: 50px;
  cursor: pointer;
  float: right;
  position: relative;
  height: 100%;
}
.header.is-ticky .menu-top .header-cart:before {
  background: transparent;
}
.header.is-ticky .hiden-ticky {
  display: none;
}
.menu-top .header-cart:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 1px;
  height: 100%;
  background: #ebebeb;
}
.menu-top .menu-action {
  position: static;
}
#header-content .header-inner .site-nav li a:hover {
  transition: none;
}
.header-inner .site-nav > li > a {
  padding-top: 0;
}
.menu-top .menu-action .megamenu {
  line-height: 0;
  position: static;
}
.header-inner .site-nav {
  line-height: 2em;
  margin-top: 7px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
#header-content .header-inner .site-nav li .nav-dropdown .title-group a {
  color: #fff !important;
  border-bottom: 1px solid #525252;
}
#header-content .header-inner .site-nav li .nav-dropdown li a {
  color: #858585 !important;
  padding: 12px 10px 12px 0px;
  text-transform: uppercase;
  font-size: 0.833em;
}
#header-content .header-inner .site-nav li .nav-dropdown li a:hover {
  color: #fff !important;
}
.row.header-mar {
  margin: 0;
}

/* top header */
.header-top-currency .top-currency .top-bar-dropdown [data-translate] {
  visibility: visible !important;
}
.top-bar-dropdown [data-translate] {
  visibility: hidden !important;
}
.top-currency:hover .top-bar-dropdown [data-translate] {
  visibility: visible !important;
}

.top-currency .selectize-input {
  min-height: auto;
}
#header-content {
  position: relative;
  z-index: 9999;
  width: 100%;
  top: 0;
  left: 0;
  margin-bottom: 0;
}

.top-currency > div {
  letter-spacing: 1px;
  line-height: 40px;
}
#header-content .header-inner .logo h1,
#header-content .header-inner .logo-sticky a {
  display: block;
}
#header-content .header-inner .logo h1 {
  margin-bottom: 0;
  line-height: 0;
}

.is-ticky .header-inner .logo img {
  -webkit-transition: width 2s;
  transition: width 2s;
}
#header-content .header-inner .site-nav li.level-top > a .fa {
  margin-left: 5px;
}
#header-content .header-inner .site-nav li a span.icon-dropdown {
  display: inline-block;
  font: normal normal normal 14px/1 FontAwesome;
}
#header-content .header-inner .site-nav li a span.icon-dropdown:before {
  content: "\f0d7";
}

#header-content .header-inner p.top-cart-p {
  display: block;
  font-size: 18px;
  cursor: pointer;
  vertical-align: bottom;
  position: relative;
  line-height: 32px;
  margin: 0;
}
#cart-hover {
  right: 0;
  color: #000;
  left: auto;
  top: 78px;
}
.col-main .grid-item.product-item.col-md-4 {
  margin-bottom: 40px;
}
.template-index .breadcrumb-wrap {
  display: none;
}
#cart .cart-buttons {
  margin: 30px 0 0;
  text-align: right;
}
.top-bar-dropdown {
  background: #fff none repeat scroll 0 0;
  padding: 15px;
  position: absolute;
  right: 0;
  opacity: 0;
  z-index: -99;
  text-align: left;
  top: 70px;
  width: 210px;
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  visibility: hidden;
  -webkit-box-shadow: -2px 2px 82px -26px rgba(0, 0, 0, 0.25);
  box-shadow: -2px 2px 82px -26px rgba(0, 0, 0, 0.25);
}
.customer-links li i {
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  -ms-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
}
.customer-links li a:hover {
  border-bottom: none;
}

.social {
  float: right;
  border-left: 1px solid #ebebeb;
  margin-left: 15px;
}
.customer-links > li {
  line-height: 30px;
}
.customer-links li,
.customer-links li a {
  font-size: 13px;
  font-weight: normal;
  margin: 0;
}
.customer-links li {
  border-top: 1px solid rgba(234, 234, 234, 0.5);
  padding: 6px 0;
}
.customer-links li.wishlist-menu {
  border-top: 0;
}
.customer-links li a {
  font-size: 14px;
  font-weight: normal;
  margin: 0;
}
.top-currency .dropdown-icon {
  padding-bottom: 10px;
}
.customer-links li a i {
  font-size: 12px;
}
.customer-links {
  margin: 0;
  text-align: right;
}
.customer-links > li {
  display: block;
  width: 100%;
  text-align: left;
  margin: 0 !important;
  border-top: 1px solid rgba(234, 234, 234, 0.5);
  padding: 6px 0;
}
.customer-links > li a {
  text-transform: capitalize;
}
.breadcrumb {
  margin-bottom: 0;
  list-style: none;
  background-color: transparent;
  padding: 0;
}
.breadcrumb .icon:before {
  content: "\c251";
  font-family: cleversoft;
  display: inline-block;
  color: #959595;
  font-size: 4px;
  line-height: 1;
}

.apply-credit-btn {
  text-decoration: none;
  color: #000 !important;
  border: 1px solid #000;
  background-color: #fff;
  padding: 5px 10px;
  font-size: 14px;
  position: relative;
  width: 100% !important;
  display: block;
  text-align: center;
  text-transform: uppercase;
  font-family: "Poppins";
}
.pay-credit-btn {
  text-decoration: none;
  color: #fff !important;
  border: 1px solid #000;
  background-color: #000;
  padding: 5px 10px;
  font-size: 14px;
  position: relative;
  width: 100% !important;
  display: block;
  text-align: center;
  text-transform: uppercase;
  font-family: "Poppins";
}
.black .header.is-ticky .apply-credit-btn {
  color: #fff !important;
  border: 1px solid #fff !important;
  background-color: #000;
  padding: 5px 10px;
  font-size: 14px;
  position: relative;
  width: 100% !important;
  display: block;
  text-align: center;
  text-transform: uppercase;
}
.black .header.is-ticky .pay-credit-btn {
  color: #000 !important;
  border: 1px solid #000;
  background-color: #fff;
  padding: 5px 10px;
  font-size: 14px;
  position: relative;
  width: 100% !important;
  display: block;
  text-align: center;
  text-transform: uppercase;
}
.signin {
  display: inline;
}
.header.is-ticky .signin {
  display: none;
}
.signinwhite {
  display: none;
}
.header.is-ticky .signinwhite {
  display: inline;
}
.shoppingbag {
  display: inline;
}
.header.is-ticky .shoppingbag {
  display: none;
}
.shoppingbagwhite {
  display: none;
}
.header.is-ticky .shoppingbagwhite {
  display: inline;
}
.top-cart a {
  align-items: center;
  display: flex;
}
#header-content .menu-actio .site-nav li.mega-menu .nav-dropdown li a {
  color: #666666;
}
.header-cart .top-cart a.cartToggle i {
  font-size: 22px;
  position: relative;
  display: inline-block;
}
.header-cart .top-cart a.cartToggle i.clever-icon-cart-6 {
  font-weight: 700;
  margin: 0.3em 0;
  border: 2px solid #000000;
  color: #000000;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  width: 28px;
  height: 28px;
}
.header-cart .top-cart a.cartToggle i.clever-icon-cart-6:before {
  transition: height 0.1s ease-out;
  bottom: 100%;
  margin-bottom: 0;
  margin-left: -7px;
  height: 8px;
  width: 14px;
  left: 50%;
  content: " ";
  position: absolute;
  pointer-events: none;
  border: 2px solid #000000;
  border-top-left-radius: 99px;
  border-top-right-radius: 99px;
  border-bottom: 0;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.header.is-ticky .header-cart .top-cart a.cartToggle i.clever-icon-cart-6 {
  border-color: #ffffff;
  color: #ffffff;
}

.header.is-ticky a {
}
.header.is-ticky
  .header-cart
  .top-cart
  a.cartToggle
  i.clever-icon-cart-6:before {
  border-color: #ffffff;
}
.header-cart .top-cart a.cartToggle:hover i.clever-icon-cart-6 {
  background: #000;
}
.header-cart .top-cart a.cartToggle:hover i.clever-icon-cart-6:before {
  height: 10px;
  border-color: #000;
}
.header-cart .top-cart a.cartToggle:hover i.clever-icon-cart-6 .cart-count {
  color: #fff;
}
.wrapper-container {
  transition: transform 0.5s ease 0s;
  overflow: hidden;
}

#off-canvas-button .off-canvas-nav {
  font-size: 22px;
  color: #000;
  cursor: pointer;
}
#off-canvas-button .off-canvas-nav i {
  width: 32px;
  height: 32px;
  display: inline-block;
  position: relative;
}
#off-canvas-button .off-canvas-nav i:before,
#off-canvas-button .off-canvas-nav i:after {
  content: "";
  position: absolute;
  height: 2px;
  width: 100%;
  top: 50%;
  left: 0;
  margin-top: -1px;
  background: #000;
}
#off-canvas-button .off-canvas-nav i:before {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
#off-canvas-button .off-canvas-nav i:after {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
#off-canvas-button .off-canvas-nav i:hover:before,
#off-canvas-button .off-canvas-nav i:hover:after {
  background: #bc3c52;
}
#off-canvas-button {
  padding: 60px 30px 0 0;
  float: right;
  position: relative;
  z-index: 9;
}
#offcanvas li.search-mobile {
  height: 50px;
}
#offcanvas {
  margin: 0;
  width: 85vw;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  padding: 0 25px 0 0;
  z-index: -1;
  visibility: hidden;
  opacity: 0;
  transition: all 300ms;
  height: 100vh;
}
nav.offcanvas-mainnav.containers {
  padding: 0 !important;
  width: auto !important;
  padding-top: 20px !important;
  height: 100%;
  margin: auto;
}
#offcanvas.active {
  visibility: visible;
  opacity: 1;
  z-index: 99999;
  transition: z-index 0ms, opacity 300ms;
}
.wrapper-container {
  transition: all 0.5s ease 0s;
  -o-transition: all 0.5s ease 0s;
  -moz-transition: all 0.5s ease 0s;
  -webkit-transition: all 0.5s ease 0s;
}

.logo {
  position: relative;
  display: none;
  padding: 0;
  margin: 0;
}
.logo a {
  line-height: 0;
}
.logo-sticky img {
  max-width: 100%;
}

.logo {
  display: block;
  line-height: 0;
}
.logo-sticky {
  display: none;
}
.header.is-ticky {
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.07000000000000001);
  width: 100%;
  z-index: 9999;
  background: #fff;
  overflow: hidden;
}
.black .header.is-ticky{
  background: #000;
}
.header-inner {
  background: transparent;
  position: relative;
  width: 100%;
  padding: 0;
  margin-top: 0;
  display: inline-block;
}
.wishlist-header {
  display: inline-block;
}
.wishlist-header a i {
  margin: 0;
  padding: 0px 8px;
  cursor: pointer;
  font-size: 22px;
}
.top-currency:hover .top-bar-dropdown {
  opacity: 1;
  top: 39px;
  visibility: visible;
  z-index: 99999;
}
.page_header_title {
  font-size: 80px;
  color: #fff;
  font-weight: lighter;
  letter-spacing: 0.5px;
  margin-bottom: 0;
  margin-top: 0;
}
.header-layout-02 .header-inner .logo-container {
    text-align: left;
    width: fit-content;
}
.header-layout-02 .header-inner {
    padding: 10px 0 0;
}

@media (max-width: 768px) {
  .line-bar,
  .credit-container,
  .header.is-ticky .menu-top{
    display: none;
  }
  .header.is-ticky {
    max-width: 100vw;
    overflow: hidden;
  }
}
</style>